/**
 * ⚠️ WARNING ⚠️
 * This file is automatically generated, do not edit it manually",
 */

import React from "react";

import { smartphoneOffblack } from "../assets/smartphone-offblack";
import {
  type StaticIllustrativeBaseIconProps,
  StaticIllustrativeIcon,
} from "../static-illustrative-icon";

export const IllustrativeIconSmartphoneOffblack = (props: StaticIllustrativeBaseIconProps) => (
  <StaticIllustrativeIcon {...props} svg={smartphoneOffblack.svg} />
);

IllustrativeIconSmartphoneOffblack.displayName = "IllustrativeIconSmartphoneOffblack";
